import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

/**
 * Manual underwriting + override reason dialogs shared across court bond retrieval pages.
 */
export function BondRetrievalUnderwritingDialogs({
  manualUnderwritingDialogOpen,
  setManualUnderwritingDialogOpen,
  manualUnderwritingReason,
  setManualUnderwritingReason,
  handleSubmitManualUnderwriting,
  overrideReasonDialogOpen,
  setOverrideReasonDialogOpen,
  overrideReason,
  setOverrideReason,
  handleSubmitOverrideReason,
  isUnderwritingLoading,
}) {
  return (
    <>
      <Dialog
        open={manualUnderwritingDialogOpen}
        onClose={() => setManualUnderwritingDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Trigger Underwriting</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Reason"
            placeholder="Enter reason for creating underwriting entry"
            value={manualUnderwritingReason}
            onChange={(e) => setManualUnderwritingReason(e.target.value)}
            fullWidth
            multiline
            rows={3}
            required
            error={!(manualUnderwritingReason || "").trim()}
            helperText={
              !(manualUnderwritingReason || "").trim() ? "Reason is required" : ""
            }
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setManualUnderwritingDialogOpen(false);
              setManualUnderwritingReason("");
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmitManualUnderwriting}
            disabled={
              isUnderwritingLoading || !(manualUnderwritingReason || "").trim()
            }
          >
            {isUnderwritingLoading ? "Submitting..." : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={overrideReasonDialogOpen}
        onClose={() => setOverrideReasonDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Override Underwriting</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Reason for override"
            placeholder="Enter reason for overriding underwriting"
            value={overrideReason}
            onChange={(e) => setOverrideReason(e.target.value)}
            fullWidth
            multiline
            rows={3}
            required
            error={!(overrideReason || "").trim()}
            helperText={!(overrideReason || "").trim() ? "Reason is required" : ""}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOverrideReasonDialogOpen(false);
              setOverrideReason("");
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="warning"
            onClick={handleSubmitOverrideReason}
            disabled={isUnderwritingLoading || !(overrideReason || "").trim()}
          >
            {isUnderwritingLoading ? "Submitting..." : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default BondRetrievalUnderwritingDialogs;
